import * as React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import PropTypes from 'prop-types';
import reactHtmlParser from 'react-html-parser';
import Svg from '../../shared/Svg';
import ObjectIcon from '../../shared/ObjectIcon';
import colors from '../../../utils/colors';
import { PopOutIcon } from '../../shared/PopOutIcon';
import * as CalendarActions from '../../../actions/calendar';
import '../../searchContainer/SearchTableItem.scss';
import { Tooltip } from '../../shared/Tooltip';

export const SelectedRecord = ({ item, isSelectedRecord }) => {
  const dispatch = useDispatch();
  const selectedRecord = useSelector((state) => state.calendar.selectedRecord);
  const type = selectedRecord?.type || item.type;
  const user = useSelector((state) => state.auth.user);
  const recordLink = `${user.salesforceInstanceUrl}/lightning/r/${type}/${item.Id}/view`;
  const objectsAndDisplayFields = useSelector((state) => state.mail.settings?.objectsAndDisplayFields);
  const currentDisplayFields = objectsAndDisplayFields?.find((object) => object.apiName === type)?.displayFields.map((field) => field.apiName) || [];
  const [, setItemHover] = useState(false);
  const isEventSaved = useSelector((state) => state.calendar.isCalendarEventSaved);

  const closeRecord = () => {
    batch(() => {
      dispatch(CalendarActions.deselectRecord());
    });
  };

  const [itemClassName, onItemClick] = ['searchTableItem-selectedRecord', () => {}];

  return (
    <div className={itemClassName} onClick={onItemClick} onMouseEnter={() => setItemHover(true)} onMouseLeave={() => setItemHover(false)}>
      {currentDisplayFields.length > 0 ? <>
        <ObjectIcon className='searchTableItem-itemImage' objectApiName={type} />
        <div className="searchTableItem-detailsContainer" >
          <Tooltip textContent={`${item[currentDisplayFields[0]] || ''}`}>
            <div className="searchTableItem-itemName">{reactHtmlParser(item[currentDisplayFields[0]]) || ''}</div>
          </Tooltip>
          {currentDisplayFields.length > 1 && currentDisplayFields.slice(1).map((displayField) => (
            <Tooltip key={`${displayField}-${item[displayField]}`} textContent={`${item[displayField] || ''}`}>
              <div className="searchTableItem-details">{reactHtmlParser(item[displayField])}</div>
            </Tooltip>
          ))}
        </div>
      </> :
        <>
          <div className="searchTableItem-detailsContainer">
            {(item['Name'] ? item['Name'] : item['Id']) + ' • ' + item['type']}
            <div className="searchTableItem-details" >Display fields not configured</div>
          </div>
        </>
      }
      <div className="searchTableItem-iconsContainer">
        <PopOutIcon link={recordLink} className={isEventSaved ? 'searchTableItem-selectedRecordPopout' : ''} />
        <Svg
          className="searchTableItem-closeIcon"
          data="../assets/close.svg"
          fill={colors.searchGrey}
          tooltipContent={<span>Clear selection</span>}
          onClickAction={ closeRecord }
          hoverable
          hoverFill={colors.iconHover}
        />
      </div>
    </div>
  );
};

SelectedRecord.propTypes = {
  item: PropTypes.object,
  isSelectedRecord: PropTypes.bool,
};
